import Icon from '../components/Icon';

const Hidden = Icon(
  'hidden',
  <>
    <path d="M2.529 9.167a.75.75 0 0 1 1.055.112 12.6 12.6 0 0 0 2.088 2.06C7.212 12.527 9.292 13.5 12 13.5c2.707 0 4.787-.973 6.327-2.16l.042-.034a12.6 12.6 0 0 0 2.048-2.027.75.75 0 0 1 1.167.942c-.48.594-1.08 1.246-1.81 1.872l1.877 3.285a.75.75 0 1 1-1.302.744l-1.778-3.111a11.6 11.6 0 0 1-3.381 1.564l.55 3.302a.75.75 0 1 1-1.48.246l-.54-3.242q-.82.117-1.72.119-.9-.002-1.72-.12l-.54 3.243a.75.75 0 1 1-1.48-.246l.55-3.302c-1.299-.36-2.422-.92-3.38-1.564L3.65 16.122a.75.75 0 1 1-1.302-.744l1.877-3.285a14.4 14.4 0 0 1-1.81-1.872.75.75 0 0 1 .113-1.054" />
  </>
);

export default Hidden;
